import { render } from "./ascension-seeker.vue?vue&type=template&id=2e070249&scoped=true"
import script from "./ascension-seeker.vue?vue&type=script&lang=js"
export * from "./ascension-seeker.vue?vue&type=script&lang=js"

import "./ascension-seeker.vue?vue&type=style&index=0&id=2e070249&scoped=true&lang=css"
import "./ascension-seeker.vue?vue&type=style&index=1&id=2e070249&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e070249"]])

export default __exports__